<div class="skin-v4-page-container list-page content-field pb-md-none">
  <div class="d-flex flex-column flex-md-row justify-content-between px-0 align-items-center">
    <div class="d-flex justify-content-between mb-3 mb-md-0 w-100 w-md-auto">
      <h3 class=" d-inline-block h3 fw-bold mb-0">
        {{ (feature?.budgetLoa ? 'BUDGET-LOA.Budget Approval' : 'SIDEBAR.MANAGE-APPROVAL') | translate }}
      </h3>
      <div class="d-flex d-md-none gap-2">
        <ng-container [ngTemplateOutlet]="createButtonTemp"></ng-container>
        <ng-container [ngTemplateOutlet]="moreActionTemp"></ng-container>
      </div>
    </div>
    <div class="d-flex gap-2 input-icon w-100 w-md-50">
      <ng-container [ngTemplateOutlet]="inputSearchTemp"></ng-container>
      <div class="d-flex gap-2">
        <div class="col-auto">
          <ng-container [ngTemplateOutlet]="filterToggleTemp"></ng-container>
        </div>
        <div class="d-none d-md-flex gap-2">
          <ng-container [ngTemplateOutlet]="createButtonTemp"></ng-container>
          <ng-container [ngTemplateOutlet]="moreActionTemp"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isLoading()" [ngTemplateOutlet]="hasLoaTemp"></ng-container>
</div>

<ng-template #createButtonTemp>
  <button class="btn btn-std-prim d-flex align-items-center h-input-res round-input px-3 btn-std-color-1-primary"
      title="{{'COMMON.Create' | translate}}"
      type="button"
      (click)="changeToCreateLoa()">
    <svg class="pointer icon-size-res"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24">
      <use href="assets/images/icons/marks/plus.svg#plus">
      </use>
    </svg>
    <span class="ms-2">{{ 'COMMON.Create' | translate }}</span>
  </button>
</ng-template>

<ng-template #moreActionTemp>
  <div ngbDropdown
      dropdownClass="dropdown-std"
      [autoClose]="true"
      [container]="'body'">
    <button class="btn btn-std-2ry btn-square-res"
        ngbDropdownToggle
        id="dropdownMoreAction">
      <i class="far fa-ellipsis-v"></i>
    </button>
    <div class="dropdown-menu p-l8"
        aria-labelledby="dropdownMoreAction"
        ngbDropdownMenu>
      <app-batch-import [type]="feature?.budgetLoa ? 'budget-loa' : 'loa'"
          (importSuccess)="importSuccess()">
        <ng-template appCustomButton>
          <button class="d-flex align-items-center"
              ngbDropdownItem
              title="{{ 'BATCH-IMPORT.IMPORT' | translate }}"
              type="button">
            <svg class="icon-size-res"
                stroke-width="1.5"
                stroke="currentColor"
                viewBox="0 0 24 24">
              <use href="assets/images/icons/arrows/arrow-down-to-line.svg#arrow-down-to-line"></use>
            </svg>
            <span class="fs-base-l0 ms-2">{{ 'BATCH-IMPORT.IMPORT' | translate }}</span>
          </button>
        </ng-template>
      </app-batch-import>
    </div>
  </div>
</ng-template>

<ng-template #inputSearchTemp>
  <div class="input-icon w-100">
    <input type="text"
        autocomplete="off"
        class="rounded-3 w-100"
        [ngModel]="filters().search"
        (ngModelChange)="updateFilter('search', $event)"
        placeholder="{{'LOA.Line of approval name' | translate}}"
        (keyup)="debouncer.next($any($event.target)?.value)" />
    <svg class="icon-prepend"
        stroke="currentColor"
        stroke-width="1.5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
      <use href="assets/images/icons/objects/search.svg#search"
          height="24"
          width="24"></use>
    </svg>
    <span *ngIf="!!searchValue"
        class="far fa-times fa-md icon-times text-dark-gray pointer"
        (click)="clearSearch()"></span>
  </div>
</ng-template>

<ng-template #filterToggleTemp>
  <app-filter-toggle-dropdown [showFilter]="isShowFilter()"
      (showFilterChange)="isShowFilter.set($event)"
      (search)="filterChange()"
      (clearFilter)="clearSearch()">
    <ng-template appCustomDetailFilter>
      <div id="item-filter"
          class="form-group mt-0">
        <label>{{ 'LOA.APPROVAL' | translate }}</label>
        <app-typeahead-dropdown bindValue="value"
            [placeholder]="'MEMOS.SELECT'"
            [bindSubLabel]="'context.job_position'"
            [clearable]="true"
            [dataGeneratorConfig]="{
              type: 'people',
              params: { can_create_memo_only: true }
            }"
            [multiple]="false"
            [showImage]="true"
            [startWith]="userChoices()"
            [ngModel]="filters().approver"
            (ngModelChange)="updateFilter('approver', $event)"
            (selectedItemChange)="onSelectApproverDropdown($event)">
        </app-typeahead-dropdown>
      </div>
      <div id="item-filter"
          class="form-group">
        <label>{{ (feature?.budgetLoa ? 'BUDGET-LOA.Budget department' : 'CREATE-USER.DEPARTMENT') | translate
          }}</label>
        <app-department-dropdown-std [ngModel]="filters().department_id"
            (ngModelChange)="updateFilter('department_id', $event)"></app-department-dropdown-std>
      </div>
      <ng-container *ngIf="feature?.budgetLoa"
          [ngTemplateOutlet]="budgetLoaFilterSet"></ng-container>
    </ng-template>
  </app-filter-toggle-dropdown>
</ng-template>

<ng-template #budgetLoaFilterSet>
  <div id="item-filter"
      class="form-group">
    <label>{{ 'BUDGET.Budget category' | translate }}</label>
    <ng-select [items]="budgetCategoryChoices()"
        class="std-skin show-full-text"
        [bindLabel]="lang() === 'en' ? 'context.display_name_en': 'context.display_name'"
        bindValue="value"
        [notFoundText]="'SELECT.No items found'|translate"
        placeholder="{{'MEMOS.SELECT' | translate}}"
        [ngModel]="filters().category"
        (ngModelChange)="updateFilter('category', $event)">
    </ng-select>
  </div>
  <div id="item-filter"
      class="form-group">
    <label>{{ 'BUDGET-LOA.Budget condition' | translate }}</label>
    <ng-select [items]="isOverBudgetChoices"
        class="std-skin"
        bindValue="value"
        [notFoundText]="'SELECT.No items found'|translate"
        placeholder="{{'MEMOS.SELECT' | translate}}"
        [ngModel]="filters().is_over_budget"
        (ngModelChange)="updateFilter('is_over_budget', $event)">
      <ng-template ng-option-tmp
          let-item="item">
        {{ item.label | translate }}
      </ng-template>
      <ng-template ng-label-tmp
          let-item="item">
        {{ item.label | translate }}
      </ng-template>
    </ng-select>
  </div>
  <div *ngIf="filters().is_over_budget === 'false'"
      id="item-filter"
      class="form-group">
    <label>{{ 'BUDGET-LOA.Amount' | translate }}</label>
    <input class="form-control h-input-res"
        [placeholder]="'BUDGET-LOA.Amount' | translate"
        name="number"
        currencyMask
        [options]="{
          prefix: '',
          align: 'left',
          allowNegative: false,
          inputMode: 1,
          nullable: true
        }"
        [ngModel]="filters().amount"
        (ngModelChange)="updateFilter('amount', $event)">
  </div>
</ng-template>

<ng-template #emptyTemp>
  <div class="row h-100 w-100">
    <div class="col h-100">
      <div class="h-100 d-flex flex-column justify-content-center align-items-center">
        <app-svg-page-placeholder class="w-100"
            [backgroundImage]="{
              y: '10px'
            }"
            [height]="100"
            [standImage]="{
              fill: '#9da0ab',
              src: 'assets/images/pictograms/person.svg#person',
              stroke: '#eaeaed',
              width: '86px',
              height: '106px',
            }">
        </app-svg-page-placeholder>
        <label class="fs-base-u5 fw-bold mb-l12">
          {{ 'LOA.LOA-EMPTY.TITLE' | translate }}
        </label>
        <div class="fs-u0 mb-0 text-gray-neutrals">
          {{ 'LOA.LOA-EMPTY.SUB-1' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #hasLoaTemp>
  <!-- ordering row -->
  <!-- <div class="d-flex flex-nowrap align-items-center justify-content-between justify-content-md-end mt-3">
    <app-list-sorts class="col-auto"
        style="min-width: 224px"
        [ngModel]="ordering()"
        (ngModelChange)="ordering.set($event)"
        [sortChoices]="sortChoices"
        (ngModelChange)="onSortChange()">
    </app-list-sorts>
  </div> -->

  <!-- filters display -->
  <ng-container *ngIf="isInAdvanceSearchStage()">
    <ng-container [ngTemplateOutlet]="filtersDisplayTemp"></ng-container>
  </ng-container>

  <!-- table -->
  <div class="table-panel datatable-wrapper mt-3">
    <div class="table-panel-body">
      <p-table class="fixed_header w-100 m-0"
          [tableStyleClass]="'table-v4'"
          [resizableColumns]="false"
          responsiveLayout="scroll"
          [value]="loaList()">
        <ng-template pTemplate="header">
          <tr class="table-header">
            <th>
              {{"LOA.Line of approval name" | translate}}
            </th>
            <th>
              {{ 'COMMON.Created by' | translate }}
            </th>
            <th [style.width.em]="5">
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body"
            let-data
            let-rowIndex="rowIndex">
          <tr class="pointer"
              (click)="changeToEditLoa(data.id)">
            <td>
              {{ lang() === 'en' ? data.name_en : data.name }}
            </td>
            <td>
              {{ data.created_user.full_name }}
              <p class="text-gray-neutrals mb-0 width-sm fs-subtitle fw-400 mt-1">
                {{ data.created_at | date: 'dd/MM/yyyy HH:mm' }}
              </p>
            </td>
            <td (click)="$event.stopPropagation()">
              <app-memo-list-action-menus [showEditMenu]="true"
                  [showEditMenu]="true"
                  [showDeleteMenu]="true"
                  (editClick)="changeToEditLoa(data.id)"
                  (deleteClick)="openDeleteModal(data)"
                  (click)="$event.stopPropagation()">
              </app-memo-list-action-menus>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="!searchNotFound()"
        class="col-12 col-sm-6 col-md-auto col-lg-auto w-100 px-4 py-2 mb-3 mb-md-0">
      <app-pagination [count]="count()"
          [boundaryLinks]="true"
          [newDesign]="true"
          [page]="pagination().page"
          [pageSize]="pagination().page_size"
          (pageChange)="changePage($event)"
          (pageSizeChange)="changePageSize($event)">
      </app-pagination>
    </div>
    <div *ngIf="searchNotFound()"
      class="content-empty search-not-found">
    <ng-container *ngIf="!isEmpty() else emptyTemp">
      <app-search-not-found-place-holder></app-search-not-found-place-holder>
    </ng-container>
  </div>
  </div>
</ng-template>

<ng-template #confirmDeleteModal
    let-modal>
  <app-modal-confirmation-std4-skin [header]="'MEMOS.CONFIRM-DELETE' | translate"
      [title]="'MEMOS.Are you sure you want to delete this item?' | translate"
      [subtitle]="'MEMOS.This action is permanent and cannot be undone.' | translate"
      [submitText]="'COMMON.Confirm' | translate"
      [dismissText]="'COMMON.Cancel' | translate"
      (dismiss)="modal.dismiss()"
      (submitted)="modal.close()">
    <ng-template>
      <svg height="56"
          width="56"
          fill="#1958d3">
        <use height="56"
            width="56"
            href="assets/images/icons/marks/question-fill.svg#question-fill"></use>
      </svg>
    </ng-template>
  </app-modal-confirmation-std4-skin>
</ng-template>

<ng-template #filtersDisplayTemp>
  <div class="px-base-l0 mt-3 bg-white border-gray-anti-flash round-input">
    <div class="row gx-l0 justify-content-between py-base-l10">
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <svg class="text-gray-pantone me-base-l6"
              height="16"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 20 20"
              width="16">
            <use href="assets/images/icons/graphics/sliders-h.svg#sliders-h">
            </use>
          </svg>
          <label class="text-gray-neutrals fs-base-l4 fw-semibold mb-0">
            {{ 'MEMOS.ADVANCE-SEARCH.Filter Searched' | translate }}
          </label>
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex align-items-center text-gray-pantone h-100">
          <svg class="pointer ms-base-l4"
              height="16"
              width="16"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              (click)="clearSearch()">
            <use href="assets/images/icons/marks/x.svg#x"></use>
          </svg>
          <svg class="pointer ms-base-l4"
              height="16"
              width="16"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              (click)="isAdvSearchCollapsed.set(!isAdvSearchCollapsed())">
            <use *ngIf="!isAdvSearchCollapsed()"
                [attr.href]="'assets/images/icons/arrows/chevron-up.svg#chevron-up'"></use>
            <use *ngIf="isAdvSearchCollapsed()"
                [attr.href]="'assets/images/icons/arrows/chevron-down.svg#chevron-down'"></use>
          </svg>
        </div>
      </div>
    </div>

    <div *ngIf="!isAdvSearchCollapsed()"
        class="overflow-hidden mt-base-l10 mb-base-l6"
        @verticalCollapse>
      <div class="advance-search">
        <div class="row gx-0">
          <ng-container *ngFor="let searchItem of advanceSearchList(); let index = index; first as isFirst">
            <ng-container *ngTemplateOutlet="inputSearch;
              context: { $implicit: searchItem , isFirst: isFirst }">
            </ng-container>
            <ng-container [ngTemplateOutlet]="inlineTextTemplate"
                [ngTemplateOutletContext]="{ config: searchItem , isFirst: isFirst }">
            </ng-container>
            <ng-container [ngTemplateOutlet]="displayTemplate"
                [ngTemplateOutletContext]="{ config: searchItem , isFirst: isFirst }">
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #inputSearch
    let-itemAdvanceSearch
    let-isFirst="isFirst">
  <span *ngIf="itemAdvanceSearch.key === 'search'"
      class="fs-base-l4 fw-semibold text-black-light">
    {{ itemAdvanceSearch.value[0].display }}
  </span>
</ng-template>

<ng-template #inlineTextTemplate
    let-config="config"
    let-isFirst="isFirst">
  <div *ngFor="let item of config.value">
    <ng-container
        *ngIf="config.key === 'department_id' || config.key === 'category' || config.key === 'amount' || config.key === 'is_over_budget'">
      <div [ngClass]="{ 'mt-base-u8 mt-base-md-u0 mt-base-lg-u8': !(isFirst )}">
        <label class="fs-base-l4 fw-semibold text-black-light me-2">
          {{ lang() === 'en' ? config.key_display_en : config.key_display }}:
        </label>
        <label class="fs-base-l4">
          {{ lang() === 'en' ? item.display_en : item.display }}
        </label>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #displayTemplate
    let-config="config"
    let-isFirst="isFirst">
  <div *ngFor="let item of config.value">
    <ng-container *ngIf="config.key === 'approver'">
      <div [ngClass]="{ 'mt-base-u8 mt-base-md-u0 mt-base-lg-u8': !(isFirst )}">
        <label class="fs-base-l4 fw-semibold text-black-light me-2">
          {{ lang() === 'en' ? config.key_display_en : config.key_display }}:
        </label>
        <div class="row gx-2 gy-2">
          <div *ngFor="let user of config.value || []"
              class="col-auto">
            <div class="std-bubble">
              <app-profile-display [size]="24"
                  [bindName]="'display'"
                  [person]="$any(user)">
              </app-profile-display>
              <span class="fs-l0 fs-md-l1 fs-lg-l2 text-gray-neutrals">{{ user.display }}
                ({{ user.nickname || '-' }})</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>